export default __webpack_public_path__ + "static/media/farmakom_branding.bc493c6f.webp";